import { BrowserError } from '@/components/BrowserError/BrowserError';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Add analytics for 'Copy Link' button
export const BrowserNotSupported = ({ link }: { link: string }) => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('browser_not_supported');
  return (
    <BrowserError
      title={content.browserNotSupported.title[locale]}
      body={content.browserNotSupported.description[locale]}
      link={link}
    />
  );
};
